export const environment = {
  production: false,
  environmentName: 'Development',
  redirectURI: 'https://recon-dev.tooltrace.sandvik.coromant.com/auth/callback',
  apiURL: "https://api-dev.tooltrace.sandvik.coromant.com/recon-bff",
  matomoEnabled: false,
  cookieConsent: {
    enabled: true,
    oneTrust: {
      scriptUrl: 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js',
      dataDomainScript: '0195c84a-6423-76aa-a50f-eb441150dfd9-test'
    }
  }
};
